export const OPTION_FORM = 'option-form'

export const ASSESSMENT_COMMENT = 'assessment-comment'
